import ActionTypes from "./ActionTypes";
import Dispatcher from "./Dispatcher";

export default {
  all() {
    Dispatcher.dispatch({
      actionType: ActionTypes.COLLECTIONS_FETCH,
    });
  },
  find(id) {
    Dispatcher.dispatch({
      actionType: ActionTypes.COLLECTION_FETCH,
      id: id,
    });
  },
  fetchArchived() {
    Dispatcher.dispatch({
      actionType: ActionTypes.COLLECTION_ARCHIVED_FETCH,
    });
  },
  chapterEnter(chapterId, collectionId) {
    Dispatcher.dispatch({
      actionType: ActionTypes.COLLECTION_STORE_INTRO_CHAPTER_ENTER,
      collectionId,
      chapterId,
    });
  }
};
